<div class="admin-wrapper">
  <app-sidebar [collapsed]="isSidebarCollapsed" (toggleSidebar)="toggleSidebar()"></app-sidebar>

  <div class="main-content" [class.collapsed]="isSidebarCollapsed">
    <app-header (toggleSidebar)="toggleSidebar()"></app-header>

    <div class="content-area">
      <router-outlet></router-outlet>
    </div>

    <app-loader></app-loader>
    <app-footer></app-footer>
  </div>
</div>
